module.exports = __webpack_public_path__ + "assets/icon_facilities.f4ded8da.svg";